module.exports = __webpack_public_path__ + "static/media/Rocket.bd8cff79.webp";